package com.github.jangalinski.tabweb._foundation.alignment

data object HORIZONTAL : Orientation
